import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import MDButton from "components/Basics/MDButton";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import i18n from "i18n";

const DialogCreateFolder = ({
	title,
	onConfirm,
	onCancel,
	nameError,
	folderName,
	onChangeNameChange,
	isEditMode,
	description,
	onChangeDescriptionChange
}) => {
	const { t } = useTranslation();

	return (
		<Dialog open>
			<DialogTitle>
				{title}
				<IconButton
					aria-label="close"
					onClick={onCancel}
					sx={{
						position: "absolute",
						right: 8,
						top: 8,
						color: theme => theme.palette.grey[500]
					}}
				>
					<CloseIcon />
				</IconButton>
			</DialogTitle>
			<DialogContent>
				<FormControl fullWidth error={!!nameError}>
					<TextField
						required
						autoFocus
						margin="dense"
						label={t("SOURCES.FOLDER.newFolderLabel")}
						type="text"
						fullWidth
						value={folderName}
						onChange={onChangeNameChange}
						error={!!nameError}
					/>
					{nameError && <FormHelperText>{nameError}</FormHelperText>}
				</FormControl>

				<FormControl fullWidth>
					<TextField
						margin="dense"
						label={t("SOURCES.FOLDER.description")}
						type="text"
						fullWidth
						value={description}
						rows={5}
						multiline
						onChange={onChangeDescriptionChange}
					/>
				</FormControl>
			</DialogContent>
			<DialogActions>
				<MDButton variant="outlined" color="info" onClick={onCancel}>
					{i18n.t("SETTINGS.cancel")}
				</MDButton>
				<MDButton variant="contained" color="info" onClick={onConfirm}>
					{isEditMode ? i18n.t("SOURCES.FOLDER.rename") : i18n.t("SETTINGS.add")}
				</MDButton>
			</DialogActions>
		</Dialog>
	);
};

DialogCreateFolder.propTypes = {
	title: PropTypes.string.isRequired,
	onConfirm: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,
	nameError: PropTypes.string,
	folderName: PropTypes.string.isRequired,
	onChangeNameChange: PropTypes.func.isRequired,
	isEditMode: PropTypes.bool,
	description: PropTypes.string,
	onChangeDescriptionChange: PropTypes.func.isRequired
};

DialogCreateFolder.defaultProps = {
	nameError: "",
	isEditMode: false,
	description: ""
};

export default DialogCreateFolder;
